import { Component, ViewContainerRef, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { AuthService, FacebookLoginProvider } from 'angular5-social-login';

import { MessageService, AccountService } from '../../../services';
import { LoginModel, ExternalLoginModel, ExternalLoginModelToken } from '../../../models/account';
import { AppSettings, AppUtils } from '../../../helpers';

declare var activateFormLineControlPlaceholder: any;

@Component({
  selector: 'Login',
  templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onLoadCurrentUserProfile: EventEmitter<any> = new EventEmitter();
  @BlockUI('frm-login') blockUI: NgBlockUI;

  private loginModel: LoginModel = new LoginModel();

  private returnUrl: string;

  private externalLoginModel: ExternalLoginModel;
  private externalLoginTokenModel: ExternalLoginModelToken;

  constructor(private router: Router,
    private route: ActivatedRoute,
    protected vcr: ViewContainerRef,
    private _toastr: ToastsManager,
    private socialAuthService: AuthService,
    private _appUtils: AppUtils,
    private appSettings: AppSettings,
    private _messageService: MessageService,
    private _accountService: AccountService) {
    this._toastr.setRootViewContainerRef(vcr);
    localStorage.removeItem('AuthToken');

    this.route.queryParams.subscribe(params => {
      const error = params['err'];
      if (error) {
        this._toastr.error(error);
      }
      this.returnUrl = params['returnUrl'];

      const key = params['key'];
      const provider = params['provider'];

      if (key && provider) {
        this.externalLoginTokenModel = new ExternalLoginModelToken(key, provider);
        this.externalLoginToken();
      }

    });
  }

   public twitterLoginUrl = `${this.appSettings.ApiBaseUrl}/api/account/external-login?provider=Twitter`;
  // public twitterLoginUrl = 'http://creative-allies.api.aspcore.net/api/account/external-login?provider=Twitter';

  ngOnInit() {
    activateFormLineControlPlaceholder();
  }

  facebookLogin() {
    const socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
    this.socialAuthService.signIn(socialPlatformProvider).then(
      (userData) => {
        // get user data
        this.externalLoginModel
          = new ExternalLoginModel(userData.provider, userData.id, userData.email, userData.name, userData.image, userData.token);

        // do external login
        this.externalLogin();
      }
    );
  }

  login() {
    this.blockUI.start();
    this._accountService.login(this.loginModel)
      .subscribe(
        data => {
          localStorage.setItem('AuthToken', data.toString());
          this._messageService.loadCurrentUserProfile();
          this.blockUI.stop();
          if (this.returnUrl) {
            this.router.navigate([this.returnUrl]);
          } else {
            this.router.navigate(['/']);
          }
        },
        error => {
          if (error.status === 417) {
            this.router.navigate([`/account/created/${error.error}`]);
          }
          this.blockUI.stop();
          this._appUtils.ProcessErrorResponse(this._toastr, error);
        });
  }

  externalLogin() {
    this.blockUI.start();
    this._accountService.externalLogin(this.externalLoginModel)
      .subscribe(
        data => {
          localStorage.setItem('AuthToken', data.toString());
          this._messageService.loadCurrentUserProfile();
          this.blockUI.stop();
          this.router.navigate(['/']);
        },
        error => {
          this.blockUI.stop();
          this._appUtils.ProcessErrorResponse(this._toastr, error);
        });
  }

  externalLoginToken() {
    this.blockUI.start();
    this._accountService.externalLoginToken(this.externalLoginTokenModel)
      .subscribe(
        data => {
          localStorage.setItem('AuthToken', data.toString());
          this._messageService.loadCurrentUserProfile();
          this.blockUI.stop();
          this.router.navigate(['/']);
        },
        error => {
          this.blockUI.stop();
          this._appUtils.ProcessErrorResponse(this._toastr, error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/components/account/login/login.component.ts